import type { Schema } from '../api/client';
type SpokenShot = {
  dialogueLines?: Schema<'ShotDialogueLine'>[];
  dialogueMode?: 'dialogue' | 'narration';
  description?: string;
  speaker?: string;
  dialogue?: string;
};

export function dialogueMode(shot: SpokenShot) {
  if (shot.dialogueMode) return shot.dialogueMode;
  const description = (shot.description ?? '').replace(/(?:不要|不添加|无|没有)旁白/g, '');
  return /旁白|画外/.test(description) || !shot.speaker?.trim() ? 'narration' : 'dialogue';
}

export function audioDirection(shot: SpokenShot, fps = 24) {
  if (shot.dialogueLines) {
    if (!shot.dialogueLines.length) return '\n声音：只生成同步环境声，不添加对白或旁白。';
    return (
      '\n按以下时间逐句表演，画内对白由指定角色开口并同步口型；画外旁白不要求画内人物动嘴。人物轮流说话，看向指定听话人，不看摄影机或观众，不添加未列出的台词。\n' +
      shot.dialogueLines
        .map(
          (l) =>
            `${(l.startFrame / fps).toFixed(2)}–${(l.endFrame / fps).toFixed(2)}秒 · ${l.speaker} → ${l.addressMode === 'self' ? '自言自语' : l.addressMode === 'voiceover' ? '画外讲述' : '对' + l.addressees.map((a) => a.name).join('、') + '说'}；视线：${l.gaze}；听者反应：${l.listenerReaction} · ${l.mode === 'narration' ? '画外旁白' : '画内对白'} · ${l.delivery}：${l.text}`,
        )
        .join('\n')
    );
  }
  if (!shot.dialogue?.trim()) return '\n声音：只生成同步环境声，不添加对白或旁白。';
  return (
    (dialogueMode(shot) === 'narration'
      ? `\n声音：原生生成画外旁白，由${shot.speaker || '旁白'}讲述。不添加说话人物，画面内人物嘴唇自然闭合，不做口型表演。`
      : `\n声音：原生生成对白与同步口型，由${shot.speaker}在画面中说话，其他人物不说话。`) +
    `语言遵循角色声音设定（未设定时使用普通话），完整保留以下台词，不能改写、漏字或增添台词。\n台词：${shot.dialogue}`
  );
}
